import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const Mobilecontact = () => {
  return (
    <>
      <a className="mobile-contact" href="tel:+995557396727">
        <FontAwesomeIcon icon={faPhone} />
        <button className="mobile">+995 557396727</button>
      </a>
    </>
  );
};

export default Mobilecontact;
